export const GOOGLE_MAP_API_KEY = 'AIzaSyBsNBWAMSH3SLDdeT2ryQr9I7nWAX0EGNU'
export const GOOGLE_MAP_URL = `https://maps.google.com/maps/api/js?v=3.23&libraries=places&sensor=false&key=${GOOGLE_MAP_API_KEY}`
export const BUGSNAG_API_KEY = 'd334d974dc4370bfc2b1e4a9ba7172a1'
export const MAPTILER_PROD_ACCESS_TOKEN = 'vb8uM3k7OvdKd4vzuFzF'
export const MAPTILER_STAGING_ACCESS_TOKEN = 'PBlYd5t1C2hdIuDldLOu'
export const MAPTILER_DEV_ACCESS_TOKEN = 'FWrNJNwxk3Y66uQJEfJP'
export const VERIFF_SCRIPT = 'https://cdn.veriff.me/sdk/js/1.1/veriff.min.js'
export const VERIFF_INCONTEXT_SCRIPT = 'https://cdn.veriff.me/incontext/js/v1/veriff.js'
